import {Actions, createEffect, ofType} from "@ngrx/effects";
import {catchError, exhaustMap, map, of} from "rxjs";
import {ACCESS_CONFIG} from "@core/consts";
import {UserMap} from "@core/model/user-map";
import {inject, Injectable} from "@angular/core";
import {mapActions} from "@core/ngrx/actions"
import {MapService} from "@core/service/aux/map.service";

@Injectable()
export class MapEffects {
  actions$: Actions = inject(Actions)
  mapService: MapService = inject(MapService)

  loadUserMap = createEffect(() =>
    this.actions$.pipe(
      ofType(mapActions.loadUserMap),
      exhaustMap(action => this.mapService.getUserMap(action.mapId, action.full).pipe(
        map(response => {
          const userMap = response as UserMap;
          return mapActions.loadUserMapSuccess({
            userMap: userMap
          });
        }),
        catchError((error: any) => of(mapActions.loadUserMapFailed({errorMsg: "error"})))
      ))
    )
  );
}
